import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/api/client';

// Connexions parfois instables (D-25) : on réessaie les lectures, jamais les erreurs 4xx.
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status < 500) return false;
          return failureCount < 3;
        },
      },
      mutations: { retry: false },
    },
  });
}
